import Vue from 'vue'
import Router from 'vue-router'
import WXScan from '@/components/WXScan'

Vue.use(Router)

export default new Router({
  mode: 'history', // 去掉url中的#
  routes: [
    {
      path: '*',
      name: 'WXScan',
      component: WXScan
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js